import { SignIn } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';

// KinCare colour tokens (kept in sync with tailwind.config.js)
const appearance = {
  variables: {
    colorPrimary: '#4a7fa5',       // primary-500
    colorBackground: '#ffffff',
    colorInputBackground: '#ffffff',
    colorInputText: '#111827',     // gray-900
    colorText: '#111827',
    colorTextSecondary: '#6b7280', // gray-500
    colorDanger: '#dc2626',        // red-600
    borderRadius: '0.5rem',        // rounded-lg
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    spacingUnit: '1rem',
  },
  elements: {
    rootBox: 'w-full',
    card: '!rounded-xl !shadow-sm !border !border-gray-200',
    formButtonPrimary:
      '!bg-primary-600 hover:!bg-primary-700 !shadow-none !font-medium !tracking-normal',
    formFieldInput:
      'focus:!ring-primary-500 focus:!border-transparent',
    footerActionLink: '!text-primary-600 hover:!text-primary-700',
    identityPreviewEditButton: '!text-primary-600 hover:!text-primary-700',
  },
} as const;

export function LoginPage() {
  return (
    <div className="min-h-screen bg-cream-100 flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-6">
        {/* Branding above the widget */}
        <div className="text-center">
          <Link to="/" className="inline-block">
            <span className="font-fraunces text-3xl font-light tracking-tight text-navy-mid">
              <em className="font-medium text-primary-500" style={{ fontStyle: 'italic' }}>Kin</em>Care
            </span>
          </Link>
          <p className="mt-1.5 text-sm text-gray-500">Care together.</p>
        </div>

        <SignIn
          routing="path"
          path="/login"
          signUpUrl="/signup"
          afterSignInUrl="/dashboard"
          appearance={appearance}
        />
      </div>
    </div>
  );
}
